import React from 'react';
import { siteConfig } from '../../data/siteConfig';
import { formatPrice } from '../../utils/currency';

/** Visual offer only. Website Forge native product frames own live product prices. */
export function ProductOffer({
  inverse = false
}: {
  inverse?: boolean;
}) {
  const {
    product
  } = siteConfig;
  const ink = inverse ? 'text-canvas' : 'text-ink';
  const muted = inverse ? 'text-canvas/80' : 'text-ink-muted';
  return <div data-product-offer data-id="element-543" data-mp="xkg0x5xvq7rr">
      <dl className="flex flex-wrap items-end gap-x-7 gap-y-3 tabular-nums" data-id="element-544" data-mp="xhblfceyrpls">
        <div data-id="element-545" data-mp="sj0f3bnvnx8b">
          <dt className={`text-[12px] leading-relaxed ${muted}`} data-id="element-546" data-mp="smo8matbojn1">Regular price</dt>
          <dd data-regular-price className={`text-[36px] font-medium leading-tight md:text-[44px] ${ink}`} data-id="element-547" data-mp="nm0e3f5vxko2">
            <s className="decoration-[3px] md:decoration-[4px]" data-id="element-548" data-mp="io8h46qdv8d0">{formatPrice(product.regularPrice)}</s>
          </dd>
        </div>
        <div data-id="element-549" data-mp="2d0oh4psl5q9f">
          <dt className={`text-[12px] leading-relaxed ${muted}`} data-id="element-550" data-mp="2czwz6hrwvr1m">Sale price</dt>
          <dd data-sale-price className={`pb-1 text-[26px] font-semibold leading-tight md:text-[30px] ${ink}`} data-id="element-551" data-mp="5rmm1lnfz4v3">
            {formatPrice(product.samplePrice)}
          </dd>
        </div>
      </dl>
      <p data-offer-message className={`mt-3 w-fit max-w-full border px-3 py-2 text-[14px] font-medium leading-relaxed ${inverse ? 'border-champagne/40 text-champagne' : 'border-champagne bg-champagne/25 text-ink'}`} data-id="element-552" data-mp="3ryun4brbwplb">
        {product.saleMessage}
      </p>
    </div>;
}